export default __webpack_public_path__ + "9d48fd33499938e4ca73decebfe28aad.svg";